import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { CruiseManagerService } from '../../../services/resources/cruise-manager.service';
import { CruiseManagerInterface } from '../../../core/models';
import { SimpleCheckModalComponent } from '../../../common/modals/simple-check-modal.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-cruise-manager-dashboard',
  imports: [CommonModule, RouterModule, SimpleCheckModalComponent],
  standalone: true,
  template: `
    <div class="mx-auto max-w-7xl pt-6 px-4 sm:px-6 lg:px-8">
      <div class="px-4 sm:px-6 lg:px-8">
        <div class="sm:flex sm:items-center pt-6">
          <div class="sm:flex-auto">
            <h1 class="text-base font-semibold leading-6 text-gray-900">
              Cruise Manager
            </h1>
            <p class="mt-2 text-sm text-gray-700">
              A list of all the Cruise Manager for booking.
            </p>
          </div>
          <div class="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
            <button
              type="button"
              routerLink="/cruise-manager/new"
              class="justify-center disabled:opacity-25 rounded-md bg-columbus-blue-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-columbus-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-columbus-blue-600"
            >
              Create new Cruise Manager
            </button>
          </div>
        </div>
        <div class="mt-8 flow-root">
          <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div
              class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8"
              *ngIf="cruiseManager$ | async as cruiseManagers"
            >
              <table class="min-w-full divide-y divide-gray-300">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                    >
                      ID - Identifier
                    </th>
                    <th
                      scope="col"
                      class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                    >
                      Name
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Tel.
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Email
                    </th>
                    <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-0">
                      <span class="sr-only">Edit</span>
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200">
                  <tr *ngFor="let cruiseManager of cruiseManagers">
                    <td
                      class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-light text-gray-600 italic sm:pl-0"
                    >
                      {{ cruiseManager.id }}
                    </td>
                    <td
                      class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0"
                    >
                      {{ cruiseManager.name }}
                    </td>
                    <td
                      class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                    >
                      {{ cruiseManager.tel }}
                    </td>
                    <td
                      class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                    >
                      {{ cruiseManager.email }}
                    </td>
                    <td
                      class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0"
                    >
                      <div class="flex flex-row justify-around">
                        <div
                          routerLink="/cruise-manager/{{ cruiseManager.id }}"
                          class="text-columbus-blue-600 hover:text-columbus-blue-900 hover:cursor-pointer"
                        >
                          Edit<span class="sr-only">Edit</span>
                        </div>
                        <div
                          (click)="onDelete(cruiseManager)"
                          class="text-red-600 hover:text-red-900 hover:cursor-pointer"
                        >
                          Delete<span class="sr-only">Delete</span>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <!-- More people... -->
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="onDeleteToggle && selectedCruiseManager">
      <app-simple-check-modal
        [title]="'Delete Cruise Manager ' + selectedCruiseManager.name"
        [message]="'Do you want to delete the Cruise Manager?'"
        [positiveButtonText]="'Yes'"
        [negativeButtonText]="'No'"
        (close)="onCloseDeleteModal($event)"
      ></app-simple-check-modal>
    </div>
  `,
  styles: ``,
})
export class CruiseManagerDashboardComponent {
  cruiseManagerServices = inject(CruiseManagerService);
  cruiseManager$ = this.cruiseManagerServices.getCruiseManagers();

  onDeleteToggle = false;
  selectedCruiseManager: CruiseManagerInterface | undefined = undefined;

  constructor() {}
  ngOnInit(): void {}

  toggleDeleteModal() {
    this.onDeleteToggle = !this.onDeleteToggle;
  }

  onDelete(cruiseManager: CruiseManagerInterface) {
    this.selectedCruiseManager = cruiseManager;
    this.toggleDeleteModal();
  }

  onCloseDeleteModal(value: boolean) {
    if (value && this.selectedCruiseManager) {
      this.cruiseManagerServices.deleteCruiseManager(
        this.selectedCruiseManager.id,
      );
    }

    this.toggleDeleteModal();
  }
}
